import React from 'react'

import column, { IState } from './interface'

// todo: refine the type and payload with union types
interface SortChangAction {
  type: 'SORT_CHANGE'
  payload: {
    sortDirection: 'asc' | 'desc' | 'none'
    sortColumn: string
    selectedColumn: column
  }
}

interface MultiSortChangeAction {
  type: 'MULTI_SORT_CHANGE'
  payload: {
    sortMultiColumns: string[]
    sortMultiDirections: ('asc' | 'desc' | 'none')[]
    selectedColumn: column
  }
}

// todo: add reset sort button
interface ResetMultiSortAction {
  type: 'RESET_MULTI_SORT'
}

interface ChangeRowsPerPageAction {
  type: 'CHANGE_ROWS_PER_PAGE'
  payload: {
    rowsPerPage: number
  }
}

export type IAction = SortChangAction | MultiSortChangeAction | ResetMultiSortAction | ChangeRowsPerPageAction

export const tableReducer: React.Reducer<IState, IAction> = (state, action) => {
  switch (action.type) {
    case 'SORT_CHANGE': {
      const { sortColumn, sortDirection, selectedColumn } = action.payload
      return {
        ...state,
        sortColumn,
        selectedColumn,
        sortDirection,
      }
    }

    case 'MULTI_SORT_CHANGE': {
      const { sortMultiColumns, sortMultiDirections, selectedColumn } = action.payload
      return {
        ...state,
        sortMultiColumns,
        sortMultiDirections,
        selectedColumn,
      }
    }

    case 'CHANGE_ROWS_PER_PAGE': {
      const { rowsPerPage } = action.payload
      return {
        ...state,
        rowsPerPage,
      }
    }

    default:
      return state
  }
}
